module.exports = __webpack_public_path__ + "static/media/nu.3f74c175.svg";